"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWeb3Context = useWeb3Context;
exports.useNetworkName = useNetworkName;
exports.useEtherscanLink = useEtherscanLink;
exports.useAccountEffect = useAccountEffect;
exports.useNetworkEffect = useNetworkEffect;
exports.useAccountAndNetworkEffect = useAccountAndNetworkEffect;
exports.useAccountBalance = useAccountBalance;
exports.useERC20Balance = useERC20Balance;
exports.useSignPersonalManager = useSignPersonalManager;
exports.useTransactionManager = useTransactionManager;

var _react = require("react");

var _Web3Context = _interopRequireDefault(require("./Web3Context"));

var _web3Utilities = require("./web3Utilities");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function useWeb3Context() {
  return (0, _react.useContext)(_Web3Context.default);
}

function useNetworkName(networkId) {
  var context = useWeb3Context();
  return (0, _react.useMemo)(function () {
    return (0, _web3Utilities.getNetworkName)(networkId || context.networkId);
  }, [networkId, context.networkId]);
}

function useEtherscanLink(type, data, networkId) {
  var context = useWeb3Context();
  return (0, _react.useMemo)(function () {
    return (0, _web3Utilities.getEtherscanLink)(networkId || context.networkId, type, data);
  }, [networkId, context.networkId, type, data]);
}

function useAccountEffect(effect) {
  var depends = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var context = useWeb3Context();
  (0, _react.useEffect)(effect, _toConsumableArray(depends).concat([context.networkId, context.account, context.reRenderers.accountReRenderer]));
}

function useNetworkEffect(effect) {
  var depends = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var context = useWeb3Context();
  (0, _react.useEffect)(effect, _toConsumableArray(depends).concat([context.networkId, context.reRenderers.networkReRenderer]));
}

function useAccountAndNetworkEffect(effect) {
  var depends = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var context = useWeb3Context();
  useAccountEffect(effect, depends.concat([context.reRenderers.networkReRenderer]));
}

function useAccountBalance(address) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$numberOfDigits = _ref.numberOfDigits,
      numberOfDigits = _ref$numberOfDigits === void 0 ? 3 : _ref$numberOfDigits,
      format = _ref.format;

  var context = useWeb3Context();

  var _useState = (0, _react.useState)(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      balance = _useState2[0],
      setBalance = _useState2[1];

  useAccountEffect(function () {
    (0, _web3Utilities.getAccountBalance)(context.web3js, address || context.account, format).then(function (balance) {
      return setBalance(Number(balance).toLocaleString(undefined, {
        maximumFractionDigits: numberOfDigits
      }));
    });
  });
  return balance;
}

function useERC20Balance(ERC20Address, address) {
  var numberOfDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  var context = useWeb3Context();

  var _useState3 = (0, _react.useState)(undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      ERC20Balance = _useState4[0],
      setERC20Balance = _useState4[1];

  useAccountEffect(function () {
    (0, _web3Utilities.getERC20Balance)(context.web3js, ERC20Address, address || context.account).then(function (balance) {
      return setERC20Balance(Number(balance).toLocaleString(undefined, {
        maximumFractionDigits: numberOfDigits
      }));
    });
  });
  return ERC20Balance;
}

var initialSignature = {
  state: 'ready',
  data: {
    signature: undefined,
    signatureError: undefined
  }
};

function signatureReducer(state, action) {
  switch (action.type) {
    case 'ready':
      return initialSignature;

    case 'pending':
      return {
        state: 'pending',
        data: initialSignature.data
      };

    case 'success':
      return {
        state: 'success',
        data: _objectSpread({}, state.data, action.data)
      };

    case 'error':
      return {
        state: 'error',
        data: _objectSpread({}, state.data, action.data)
      };

    default:
      return initialSignature;
  }
}

function useSignPersonalManager(message) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$handlers = _ref2.handlers,
      handlers = _ref2$handlers === void 0 ? {} : _ref2$handlers;

  var context = useWeb3Context();

  var _useReducer = (0, _react.useReducer)(signatureReducer, initialSignature),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      signature = _useReducer2[0],
      dispatch = _useReducer2[1];

  function _signPersonal() {
    dispatch({
      type: 'pending'
    });
    (0, _web3Utilities.signPersonal)(context.web3js, context.account, message).then(function (signature) {
      dispatch({
        type: 'success',
        data: {
          signature: signature
        }
      });
      handlers.success && handlers.success(signature);
    }).catch(function (error) {
      dispatch({
        type: 'error',
        data: {
          signatureError: error
        }
      });
      handlers.error && handlers.error(error);
    });
  }

  function resetSignature() {
    dispatch({
      type: 'ready'
    });
  }

  return [signature.state, signature.data, _signPersonal, resetSignature];
}

var initialTransaction = {
  state: 'ready',
  data: {
    transactionHash: undefined,
    transactionReceipt: undefined,
    transactionConfirmations: undefined,
    transactionError: undefined,
    transactionErrorCode: undefined
  }
};

function transactionReducer(state, action) {
  switch (action.type) {
    case 'ready':
      return initialTransaction;

    case 'sending':
      return {
        state: 'sending',
        data: initialTransaction.data
      };

    case 'pending':
      return {
        state: 'pending',
        data: _objectSpread({}, state.data, action.data)
      };

    case 'success':
      return {
        state: 'success',
        data: _objectSpread({}, state.data, action.data)
      };

    case 'error':
      return {
        state: 'error',
        data: _objectSpread({}, state.data, action.data)
      };

    default:
      return initialTransaction;
  }
}

function useTransactionManager(method) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref3$handlers = _ref3.handlers,
      handlers = _ref3$handlers === void 0 ? {} : _ref3$handlers,
      _ref3$transactionOpti = _ref3.transactionOptions,
      transactionOptions = _ref3$transactionOpti === void 0 ? {} : _ref3$transactionOpti,
      _ref3$maximumConfirma = _ref3.maximumConfirmations,
      maximumConfirmations = _ref3$maximumConfirma === void 0 ? null : _ref3$maximumConfirma;

  var context = useWeb3Context();

  var _useReducer3 = (0, _react.useReducer)(transactionReducer, initialTransaction),
      _useReducer4 = _slicedToArray(_useReducer3, 2),
      transaction = _useReducer4[0],
      dispatch = _useReducer4[1];

  var wrappedHandlers = {
    transactionHash: function transactionHash(_transactionHash) {
      dispatch({
        type: 'pending',
        data: {
          transactionHash: _transactionHash
        }
      });
      handlers.transactionHash && handlers.transactionHash(_transactionHash);
    },
    receipt: function receipt(transactionReceipt) {
      dispatch({
        type: 'success',
        data: {
          transactionReceipt: transactionReceipt
        }
      });
      handlers.receipt && handlers.receipt(transactionReceipt);
    },
    confirmation: function confirmation(transactionConfirmations, transactionReceipt) {
      if (maximumConfirmations && transactionConfirmations <= maximumConfirmations) {
        dispatch({
          type: 'success',
          data: {
            transactionConfirmations: transactionConfirmations,
            transactionReceipt: transactionReceipt
          }
        });
        handlers.confirmation && handlers.confirmation(transactionConfirmations, transactionReceipt);
      }
    }
  };

  function _sendTransaction() {
    dispatch({
      type: 'sending'
    });
    (0, _web3Utilities.sendTransaction)(context.web3js, context.account, method, wrappedHandlers, transactionOptions).catch(function (error) {
      var transactionErrorCode = _web3Utilities.TRANSACTION_ERROR_CODES.includes(error.code) ? error.code : undefined;
      dispatch({
        type: 'error',
        data: {
          transactionError: error,
          transactionErrorCode: transactionErrorCode
        }
      });
      handlers.error && handlers.error(error);
    });
  }

  function resetTransaction() {
    dispatch({
      type: 'ready'
    });
  }

  return [transaction.state, transaction.data, _sendTransaction, resetTransaction, _web3Utilities.TRANSACTION_ERROR_CODES];
}